/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function PageHeaders() {

  const navigate = useNavigate();

  useEffect(() => {
    // Detect user's device
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Check if iOS
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    // Check if Android
    const isAndroid = /android/i.test(userAgent);

    // Set destination URLs
    const url1 = "https://apps.apple.com/us/app/aws-cloud-practitioner-clf/id6746692850";
    const url2 = "https://play.google.com/store/apps/details?id=com.techcoo.DoPaper.clfc02";

    // Determine where to redirect based on device
    if (isIOS) {
      window.location.href = url1;
    } else if (isAndroid) {
      window.location.href = url2;
    } else {
      window.location.href = url1;
    }

  }, [navigate]);

  return (
    <></>
  );
}

export default PageHeaders;
